<template>
    <div class="" v-show="isShow">
        <div class="login-popup promotion-popup">
            <a href="javascript:void(0)" v-on:click="closePopup()" class="btn-close dark">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                        <path d="M76 11.251l-7.252-7.251-28.748 28.749-28.749-28.749-7.251 7.251 28.749 28.749-28.749 28.748 7.251 7.252 28.749-28.748 28.748 28.748 7.252-7.252-28.748-28.748z"></path>
                    </svg>
                </div>
            </a>

            <!--
            <h1>User Login</h1>
            -->

            <div class="promotion-content">
                <img :src="image">
            </div>

            <!--action bottom-->
            <div class="popup-action-bottom" v-show="btn1_text || btn2_text">
                <a class="btn-signup" v-show="btn1_text" v-on:click="clickBtn1()">{{ btn1_text }}</a>
                <a class="btn-signup" v-show="btn2_text" v-on:click="clickBtn2()">{{ btn2_text }}</a>
            </div>
            <!--end action bottom-->
        </div>
        <div class="dark-mask"></div>

    </div>
</template>

<script>

    import EventBus from '@common/eventBus';
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import {checkViewCount} from '@mixins/checkViewCount';
    import {nsw_common} from '@mixins/nsw_common';

    export default {
        name: "HkepPopup",
        mixins:[nsw_common, checkViewCount],
        data() {
            return {
                isShow: false,
                image: "",
                btn1_text: "",
                btn1_url: "",
                btn2_text: "",
                btn2_url: "",
                frontend_id: "",
                btn1_file: "",
                btn2_file: ""

            }
        },
        mounted() {
            this.listenEvents();
        },
        methods: {
            listenEvents()
            {
                EventBus.$on("show_hkep_popup", (obj)=> {

                    if (obj) {
                        this.image = window.getImageApi+obj.files.image;
                        this.btn1_text = obj.btn1_text;
                        this.btn1_url = obj.btn1_url;
                        this.btn2_text = obj.btn2_text;
                        this.btn2_url = obj.btn2_url;
                        this.frontend_id = obj.frontend_id;
                        this.btn1_file = obj.files.btn1_file;
                        this.btn2_file = obj.files.btn2_file;

                        if (this.isShowPopup(this.frontend_id)) {
                            this.showPopup();

                            this.initViewCount(this.frontend_id);

                        }
                    }

                });
            },
            showPopup()
            {
                this.isShow = true;
            },
            closePopup()
            {
                this.isShow = false;
            },
            clickBtn1()
            {

                let self = this;
                if (this.btn1_url) {
                    window.open(this.btn1_url, "_blank");
                } else {
                    nsw_common.openUrlByPath(this.btn1_file);


                }

            },
            clickBtn2()
            {
                let self = this;

                if (this.btn2_url) {
                    window.open(this.btn2_url, "_blank");
                } else {

                    nsw_common.openUrlByPath(this.btn2_file);

                }

            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HkepPopup.vue